/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEuNzUgMy45Mzc1SDEyLjI1VjUuNjg3NUgxLjc1VjMuOTM3NVpNMS43NSA4LjMxMjVIMTIuMjVWMTAuMDYyNUgxLjc1VjguMzEyNVoiIGZpbGw9IiM3RjdGN0YiLz48L3N2Zz4=";